import Siema from "modules/siema";
import cookie from "modules/cookie";

import { WidgetInstance } from "friendly-challenge";

import "./top-page-carousel-block.scss";

(function () {
    if (document.querySelectorAll(".js-top-page-carousel-block").length < 1) return;

    const siemas = document.querySelectorAll(".siematop");
    const defaultOptions = {
        invalidEmailText: "Please enter a valid email",
        invalidPhoneText: "Please enter a valid phone number",
        missingEmailText: "Email must be entered",
        missingPhoneText: "Phone must be entered",
        sendFailText: "Something went wrong, please try again later",
        cookieFail: "To be able to send this form you have to allow the cookie '_grecaptcha'. This is used to prevent spam.",
        siteKey: "",
        language: "en",
    };

    let currentSendButton;
    let currentForm;
    let formContentReferenceData;
    let formSlideTitleData;
    let formSlideTextData;
    let formDescriptionData;
    let formTextData;
    let formTextDivData;
    let formButtonData;
    let formValidationMassageData;
    let formErrorMsgData;
    let formSuccessTitleData;
    let formSuccessMsgData;
    let formMyFormData;

    function TopPageCarousel(options) {
        this.options = Object.assign({}, defaultOptions, options);
        this.submitRequest = this.submitRequest.bind(this);
        this.SaveData = this.SaveData.bind(this);
        this.validate = this.validate.bind(this);
        this.friendlyCaptchaDone = this.friendlyCaptchaDone.bind(this);

        this.buttons = document.querySelectorAll(".js-top-page-carousel-block .input_button_carousel");

        this.solution = "";
        if (options?.siteKey && options.siteKey !== '') {
            // This element should contain the `frc-captcha` class for correct styling
            const element = document.querySelector("#top-page-frc-captcha-widget");
            if (element) {
                this.buttons.forEach(button => {
                    button.setAttribute("disabled", "disabled");
                });

                const opts = {
                    doneCallback: this.friendlyCaptchaDone,
                    sitekey: options.siteKey,
                    startMode: "focus",
                    language: options.language
                };

                new WidgetInstance(element, opts);
            }
        }

        document.querySelector(".slide.grid form")?.addEventListener("submit", (e) => e.preventDefault());

        for (const siema of siemas) {
            const slider = new Siema({
                loop: true,
                duration: 200,
                selector: siema,
                onChange: () => {
                    this.changeSlideInidicator(
                        slider,
                        slider.currentSlide
                    );
                },
            });

            const controlsContainer = slider.config.selector.nextElementSibling;

            if (controlsContainer !== null) {
                const prevButton = controlsContainer.querySelector(
                    ".carousel__prev"
                );
                const nextButton = controlsContainer.querySelector(
                    ".carousel__next"
                );

                if (prevButton !== null) {
                    prevButton.addEventListener("click", () => {
                        slider.prev();
                    });
                }

                if (nextButton !== null) {
                    nextButton.addEventListener("click", () => {
                        slider.next();
                    });
                }
            }
        }
        this.SaveData();

    }

    TopPageCarousel.prototype = {
        friendlyCaptchaDone(solution) {
            this.buttons.forEach(button => {
                button.removeAttribute("disabled");
            });
            this.solution = solution;
        },
        changeSlideInidicator: (slider, slideIndex) => {
            const indicatorContainer = slider.config.selector.nextElementSibling;
            const indicators = indicatorContainer.querySelectorAll(
                ".slide__indicator"
            );
            indicators.forEach((indicator) => {
                if (slideIndex == indicator.getAttribute("data-index")) {
                    indicator.classList.add("active");
                } else {
                    indicator.classList.remove("active");
                }
            });
        },

        validate(inputType) {
            let valid = true;
            if (inputType.type == "email") {
                if (inputType.value.length === 0) {
                    this.showError(inputType, this.options.missingEmailText);
                    valid = false;
                }
                if (inputType.value.length > 0 && !this.emailValid(inputType.value)) {
                    valid = false;
                    this.showError(inputType, this.options.invalidEmailText);
                }
            }

            if (inputType.type == "number") {
                if (inputType.value.length === 0) {
                    this.showError(inputType, this.options.missingPhoneText);
                    valid = false;
                }

                if (inputType.value.length > 0 && !this.phoneValid(inputType.value)) {
                    valid = false;
                    this.showError(inputType, this.options.invalidPhoneText);
                }
            }
            return { valid };
        },
        phoneValid(phone) {
            return phone.length > 4;
        },
        emailValid(email) {
            const re = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
            return re.test(email);
        },
        showError(input, message) {
            const formField = input.closest(".slide");
            formField.classList.add("Form__Element__ValidationError");

            const error = formField.querySelector("small");
            error.textContent = message;

            error.classList.add("fade-visible");
            // This is a hack
            // eslint-disable-next-line @typescript-eslint/no-unused-expressions
            error.clientWidth;
            error.classList.add("fade-transition");
            error.classList.add("fade-active");
        },

        /**
         * @param {string} token
         */
        submitRequest: function (token) {
            currentSendButton.setAttribute("disabled", "disabled");

            const formData = new FormData(currentForm);
            formData.set(
                "contentReference",
                formContentReferenceData.value
            );
            formData.set("sent_from_url", location.href);
            formData.set("sent_from_form", "hero-form");
            formData.set("token", token);

            function getUtmTagsFromUrlOrCookie() {
                const utmParams = decodeURIComponent(window.location.search)
                    .substr(1)
                    .split("&")
                    .filter((p) => p.indexOf("utm_") > -1);

                if (utmParams.length > 0) {
                    return utmParams.map((param) => param.split("="));
                }

                const utmCookie = cookie.getCookie("sec_utm");

                if (utmCookie.length > 0) {
                    return utmCookie.split("&").map((param) => param.split("="));
                }

                return utmParams;
            }

            const utmParams = getUtmTagsFromUrlOrCookie();
            utmParams.forEach(([key, value]) => {
                formData.set(key, value);
            });

            const entries = [...formData.entries()].map(
                (e) =>
                    encodeURIComponent(e[0]) +
                    "=" +
                    encodeURIComponent(e[1])
            );

            const formBody = entries.join("&");

            fetch("/api/clickdimensions/send", {
                method: "POST",
                headers: {
                    "Content-Type":
                        "application/x-www-form-urlencoded;charset=UTF-8",
                },
                body: formBody,
            }).then((res) => {
                if (!res.ok) return;
                res.json().then((d) => {
                    if (d.success) {
                        formSlideTitleData.style.display = "none";
                        formSlideTextData.style.display = "none";
                        formDescriptionData.style.display = "none";
                        formTextData.style.display = "none";
                        formTextDivData.style.display = "none";
                        formButtonData.style.display = "none";
                        formValidationMassageData.style.display = "none";
                        formErrorMsgData.style.display = "none";
                        formSuccessTitleData.style.display = "block";
                        formSuccessMsgData.style.display = "block";
                    } else {
                        formSlideTitleData.style.display = "none";
                        formSlideTextData.style.display = "none";
                        formDescriptionData.style.display = "none";
                        formTextData.style.display = "none";
                        formTextDivData.style.display = "none";
                        formButtonData.style.display = "none";
                        formValidationMassageData.style.display = "none";
                        formErrorMsgData.style.display = "block";
                        formSuccessTitleData.style.display = "none";
                        formSuccessMsgData.style.display = "none";
                    }
                });
            });
        },
        SaveData: function () {
            const buttons = document.querySelectorAll(".js-top-page-carousel-block .button");
            // TODO: Refactor this
            // eslint-disable-next-line @typescript-eslint/no-this-alias
            const self = this;

            buttons.forEach((button) => {
                button.addEventListener("click", function (e) {
                    currentSendButton = button;

                    const currentSlide = e.target.closest(".slide");
                    ///Get id from event
                    const formSlideTitleId = "slideTitle-" + this.id;
                    const formSlideTextId = "slideText-" + this.id;
                    const formDescriptionId = "description-" + this.id;
                    const formValidationMassageId = "validationMassage-" + this.id;
                    const formContentReferenceId = "contentReference-" + this.id;
                    const formMyFormId = "myform-" + this.id;
                    const formTextId = "text-" + this.id;
                    const formTextDivId = "textDiv-" + this.id;
                    const formSuccessTitleId = "successTitle-" + this.id;
                    const formSuccessMsgId = "successMsg-" + this.id;
                    const formErrorMsgId = "errorMsg-" + this.id;

                    ///// Get data by id
                    formSlideTitleData = currentSlide.querySelector(
                        "h2[id='" + formSlideTitleId + "']"
                    );
                    formSlideTextData = currentSlide.querySelector(
                        "p[id='" + formSlideTextId + "']"
                    );
                    formDescriptionData = currentSlide.querySelector(
                        "div[id='" + formDescriptionId + "']"
                    );
                    formMyFormData = currentSlide.querySelector(
                        "form[id='" + formMyFormId + "']"
                    );
                    formTextData = currentSlide.querySelector(
                        "input[id='" + formTextId + "']"
                    );
                    formTextDivData = currentSlide.querySelector(
                        "div[id='" + formTextDivId + "']"
                    );
                    formSuccessTitleData = currentSlide.querySelector(
                        "h2[id='" + formSuccessTitleId + "']"
                    );
                    formSuccessMsgData = currentSlide.querySelector(
                        "p[id='" + formSuccessMsgId + "']"
                    );
                    formErrorMsgData = currentSlide.querySelector(
                        "p[id='" + formErrorMsgId + "']"
                    );
                    formButtonData = currentSlide.querySelector(
                        "button[id='" + this.id + "']"
                    );
                    formValidationMassageData = currentSlide.querySelector(
                        "small[id='" + formValidationMassageId + "']"
                    );
                    formContentReferenceData = currentSlide.querySelector(
                        "input[id='" + formContentReferenceId + "']"
                    );
                    currentForm = formMyFormData;
                    if (formTextData) {
                        if (self.validate(formTextData).valid) {
                            self.submitRequest(self.options.siteKey ? self.solution : "");
                        } else {
                            e.preventDefault();
                            return false;
                        }
                    }
                });
            });
        },
    }

    const carouselBlock = {
        init: () => {
            const options = window.topPageCarouselOptions || defaultOptions;

            new TopPageCarousel(options[0]);

            carouselBlock.triggerModal();
        },
        triggerModal: () => {
            const buttons = document.querySelectorAll(".js-trigger-modal");

            buttons.forEach((button) => {
                button.addEventListener("click", (e) => {

                    const id = e.target.getAttribute("data-id");
                    const modalId = "modal-slide-" + id;
                    const modal = document.getElementById(modalId);

                    modal.style.display = "flex";

                    modal.addEventListener("click", (e) => {
                        if (e.target.classList.contains("modal-slide__close") || e.target.classList.contains("modal-form-block")) {
                            modal.style.display = "none";
                        }
                    });
                })
            });
        }
    };

    carouselBlock.init();
})();
